import {ThemeMode} from '../../../../shared/constants/AppEnums';
import styled from 'styled-components';
import Box from '@material-ui/core/Box';

export const BoxContainer = styled(Box)`
  ${(props) => ` 
      padding-left: 0;
      padding-top: 0;
      padding-bottom: 0;
      position: relative;
      top: 0;
      left: 0;
      width: 19rem;
      max-height: 100vh;
      height: 100%;
      
      ${props.theme.breakpoints.up('lg')} {
        position: fixed;
      }
      
      ${props.theme.breakpoints.up('xl')} {
        width: 21.6rem;
      }
      
      & .sidebar-bg {
        background-color:
          ${
            props.themeMode === ThemeMode.SEMI_DARK
              ? props.theme.palette.sidebar.bgColor
              : props.themeMode === ThemeMode.LIGHT
              ? 'white'
              : '#313541'
          };
      }
      
      & .sidebar-standard {
          height: 100%;
          width: 100%;
          color: white;
          overflow: hidden;
      }
      
      & .scroll-app-sidebar {
          padding-top: 8px;
          padding-bottom: 20px;
          height: calc(100vh - 58px) !important;
    
          ${props.theme.breakpoints.up('xl')} {
            height: calc(100vh - 65px) !important;
          }
      }
      
      & .drawer-scroll-app-sidebar {
          padding-top: 8px;
          padding-bottom: 20px;
          height: calc(100vh - 58px) !important;
    
          ${props.theme.breakpoints.up('xl')} {
            height: calc(100vh - 65px) !important;
          }
      }  
 `}
`;
